<template>
  <div class="companyData">
    <div v-for="(item, i) in extendList" :key="i">
      <div class="rowTitle">{{ item.extendCompanyName }}</div>
      <vxe-table
        border
        resizable
        show-overflow
        :data="item.list"
        :edit-config="editConfig"
        :max-height="$store.state.app.tableHeight"
        size="mini"
        ref="extendTable"
        auto-resize
      >
        <vxe-table-column
          type="index"
          width="60"
          :title="$t('goods.table.index')"
        ></vxe-table-column>
        <vxe-table-column field="productDetailCode" title="商品子类编码"></vxe-table-column>
        <vxe-table-column field="detailProductDisplayName" title="商品名称"></vxe-table-column>
        <!-- <vxe-table-column field="purchaseOrderUnit" title="采购订单单位"></vxe-table-column>
        <vxe-table-column field="salesOrderUnit" title="销售订单单位"></vxe-table-column> -->
        <!-- <vxe-table-column
          field="detailProductDisplayName"
          :title="$t('goods.table.detailProductDisplayName')"
        ></vxe-table-column> -->
        <!-- <vxe-table-column
          field="costCourse"
          :title="$t('goods.table.costCourse')"
          :edit-render="{ name: 'select', options: dictList.costCourseOptions }"
        ></vxe-table-column> -->
        <!-- <vxe-table-column
          field="incomeCourse"
          :title="$t('goods.table.incomeCourse')"
          :edit-render="{ name: 'select', options: dictList.incomeCourseOptions }"
        ></vxe-table-column> -->
        <vxe-table-column
          field="purchaseOrderUnit"
          title="采购订单单位"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <span class="foreInput">
              <el-input value="1" size="mini" placeholder class="fstInput" disabled></el-input>
              <el-input
                :value="transferUnit(firstTabData.baseData.basicUnit, unitDictList)"
                size="mini"
                placeholder
                class="secInput"
                disabled
              ></el-input>
              <span>&lt;-&gt;</span>
              <input-number
                v-model="row.purchaseOrderUnitValue"
                size="mini"
                placeholder
                class="thrInput"
                maxlength="32"
                max="999999999"
                :precision="2"
                :clearable="true"
              ></input-number>
              <el-select
                :placeholder="$t('goods.table.pleaseChange')"
                v-model="row.purchaseOrderUnit"
                filterable
                class="fouInput"
                clearable
              >
                <el-option
                  v-for="item in unitDictList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
          </template>
          <template v-slot="{ row }"
            >1&nbsp;{{ transferUnit(firstTabData.baseData.basicUnit, unitDictList) }}&lt;-&gt;{{
              row.purchaseOrderUnitValue
            }}&nbsp; {{ transferUnit(row.purchaseOrderUnit, unitDictList) }}</template
          >
        </vxe-table-column>
        <vxe-table-column
          field="salesOrderUnit"
          title="销售订单单位"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <span class="foreInput">
              <el-input value="1" size="mini" placeholder class="fstInput" disabled></el-input>
              <el-input
                :value="transferUnit(firstTabData.baseData.basicUnit, unitDictList)"
                size="mini"
                placeholder
                class="secInput"
                disabled
              ></el-input>
              <span>&lt;-&gt;</span>
              <input-number
                v-model="row.salesOrderUnitValue"
                size="mini"
                placeholder
                class="thrInput"
                maxlength="32"
                max="999999999"
                :precision="2"
                :clearable="true"
              ></input-number>
              <el-input
                v-model="row.salesOrderUnitValue"
                size="mini"
                placeholder
                class="thrInput"
                clearable
              ></el-input>
              <el-select
                :placeholder="$t('goods.table.pleaseChange')"
                v-model="row.salesOrderUnit"
                filterable
                class="fouInput"
                clearable
              >
                <el-option
                  v-for="item in unitDictList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </span>
          </template>
          <template v-slot="{ row }"
            >1&nbsp;{{ transferUnit(firstTabData.baseData.basicUnit, unitDictList) }}&lt;-&gt;{{
              row.salesOrderUnitValue
            }}&nbsp; {{ transferUnit(row.salesOrderUnit, unitDictList) }}</template
          >
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  export default {
    name: 'companyData',
    props: ['isEdit', 'isForbiden', 'goodsDetail', 'extendList', 'firstTabData'],
    data() {
      return {
        form: {
          name: '',
        },
        loading: false,
        load: false,
        editConfig: {},
        tableArray: [], //所有公司集合
        baseData: {},
        unitDictList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.init();
      this.unitDictList = this.dictListMap?.basic_unit || [];
    },
    watch: {
      // 判断表格编辑功能是否禁用
      isEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
    },

    methods: {
      // 数据处理
      init() {
        if (this.extendList[0] != undefined) {
          for (let item of this.extendList[0].list) {
            if (!item.costCourse) {
              item.costCourse = 'CBKM2';
            }
            if (!item.incomeCourse) {
              item.incomeCourse = 'SRKM1';
            }
          }
        }
      },
      //详情一些字段赋值
      reloadData() {
        if (this.$route.name === 'goodsDetail' || this.$route.name === 'editGoods') {
          this.baseData.basicUnit = this.goodsDetail.basicUnit;
        }
      },
      //单位转换
      transferUnit(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //返回公司tab数据
      exportChildData() {
        return this.extendList;
      },
      //更新数据
      refreshData(arr, obj) {
        this.$nextTick(() => {
          this.extendList = arr;
          this.baseData = obj.baseData;
        });
        this.$forceUpdate();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .companyData .rowTitle {
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
  }
  .companyData .foreInput .fstInput {
    width: 60px;
    margin-right: 6px;
  }
  .companyData .foreInput .secInput {
    width: 60px;
    margin-right: 6px;
  }
  .companyData .foreInput .thrInput {
    width: 60px !important;
    margin: 0 6px;
  }
  .companyData .foreInput .fouInput {
    width: 60px;
  }
</style>
